import { useEffect, useState } from 'react';

const SHORTCUT_KEY = 'k';
const APPLE_PLATFORM = /Mac|iPhone|iPad|iPod/;

function isApplePlatform() {
  return typeof navigator !== 'undefined' && APPLE_PLATFORM.test(navigator.userAgent);
}

/**
 * Open state of the global search, toggled by Cmd K / Ctrl K anywhere in the space.
 * Mount it once (in the app shell) so a single listener handles the shortcut.
 */
export function useGlobalSearchShortcut() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === SHORTCUT_KEY) {
        event.preventDefault();
        setIsOpen((previous) => !previous);
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  function handleOpen() {
    setIsOpen(true);
  }

  function handleClose() {
    setIsOpen(false);
  }

  return {
    isOpen,
    handleOpen,
    handleClose,
    shortcutHint: isApplePlatform() ? '⌘ K' : 'Ctrl K',
    ariaKeyShortcuts: 'Meta+K Control+K',
  };
}
